import React from "react";
import { styled } from "@mui/system";
import StateInterface from "../../../redux-magic/state-interface";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { setBroadcastFormThunk } from "../../../redux-magic/store";
import NotesBackground from '../../../public/images/broadcast/NotesBackground.svg';
import SvgIcon from "@mui/material/SvgIcon";
// Container

const Container = styled("div")({
    width: '100vw',
    flex: 1,
    // justifyContent: 'center',
    // alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
})
const HeaderContainer = styled("div")({
    width: '100vw',
    height: '26rem',
    padding: '16px 0 0 0',
    gap: '8px',
    background: "#621B16",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems:'center',
    alignContent:'center',
});

const Title = styled(Typography)({
  fontWeight: '700',
  lineHeight: '160%',
  letterSpacing: '0.15px',
});

const SubTitle = styled(Typography)({
  lineHeight: '16%',
  letterSpacing: '0.4px',
});

const Section = styled("div")({
    width: '100vw',
    height: '205px',
    display: "flex",
    flexDirection: "column",
    justifyContent:'center',
    alignContent:'center',
    padding: "0 24px 0 24px",
});

const NotesInput = styled(TextField)({
    width: '100%',
    height: '176px',
})

const BottomBar = styled('div')({
    width: '100vw',
    maxWidth: '100vw',
    position: 'fixed',
    bottom: 0,
    background: '#fff',
    borderTop: '1px solid #F0F0F0',
    borderRadius: '24px 24px 0 0',
    boxShadow: '0 -2px 20px rgba(0,0,0,0.04)',
    padding: '16px 16px 16px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    justifyContent: 'space-between',
    zIndex: 10,
});

const TextButton = styled(Button)({
    width: '100%',
    height: '40px',
    borderRadius: '16px',
    fontSize: '16px',
    textTransform: 'none',
    color: '#621B16',
});

const FilledButton = styled(Button)({
    width: '100%',
    height: '40px',
    borderRadius: '16px',
    backgroundColor: '#621B16',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '400',
});


export default function Summary(
  {
    broadcast,
    setPage,
    dispatch,
  }: 
  {
    broadcast:  StateInterface["broadcast_data"] | undefined | null;
    setPage: Function;
    dispatch: Function; 
  }
) {

  const handleSkip = async() => {
    await dispatch(setBroadcastFormThunk({
        commission_offered: broadcast?.commission_offered || 0,
        no_of_agents: broadcast?.no_of_agents || 0,
        notes: ""
    }));
    setPage('broadcast');
  }

  return (
    <Container>
      <HeaderContainer>
        <Title variant="h6">Add additional note</Title>
        <SubTitle variant="caption">Provides better insight for our agents.</SubTitle>
        <SvgIcon
            component={NotesBackground}
            viewBox="0 100 350 70"
            sx={{
                width: '310px',
                height: '340px',
                display: 'block',
                margin: '0 auto',
            }}
        />
      </HeaderContainer>
      <Section>
        <NotesInput
            id="outlined-multiline-static"
            placeholder={'Eg. Commission is negotiable, Newly launched.'}
            multiline
            rows={5}
            defaultValue={broadcast?.notes || ""}
            onChange={async (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                const value = event.target.value;
                await dispatch(setBroadcastFormThunk({
                    commission_offered: broadcast?.commission_offered || 0,
                    no_of_agents: broadcast?.no_of_agents || 0,
                    notes: value || ""
                }));
            }}
        />
      </Section>
      <BottomBar>
        <TextButton disableRipple onClick={handleSkip}>Skip</TextButton>
        <FilledButton onClick={()=>setPage('broadcast')} disableRipple variant="contained">Next</FilledButton>
      </BottomBar>
    </Container>
  );
}
